
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { client } from './graphql/client';
import { store } from './store/configureStore';
import { AppContent } from './components/AppContent/AppContent';
import { Login } from './components/Login/Login';
import { ForgotPassword } from './components/Login/ForgotPassword/ForgotPassword';
import { RecoverPassword } from './components/Login/RecoverPassword/RecoverPassword';
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import { useForceRerenderOnLogin } from './hooks/useForceRerenderOnLogin';

export const App: React.FC = () => {
  const { renderKey } = useForceRerenderOnLogin();

  return (
    <ApolloProvider client={client} key={`apollo-key-${renderKey}`}>
      <Provider store={store} key={`store-key-${renderKey}`}>
        <BrowserRouter key={`router-key-${renderKey}`}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/recover-password" element={<RecoverPassword />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/*" element={<AppContent />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </Provider>
    </ApolloProvider>
  );
};
export default App;

